import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const NAMES = [
  "The Obama White House",
  "MSNBC",
  "Open Source Summit Europe",
  "Linux Foundation",
  "Google",
  "Comcast",
  "O'Reilly OSCON",
  "Southern California Linux Expo",
  "City of Los Angeles",
  "City of Compton",
  "Urban League Los Angeles",
  "TEDx Inglewood",
  "Black Boys Code",
];

export default function Credibility() {
  return (
    <section id="credibility" data-testid="credibility-section" className="py-32 lg:py-40 bg-muted/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-20">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          Experience
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6 max-w-4xl">
          From community classrooms to <span className="italic text-primary">global technology stages.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }} className="mt-8 max-w-2xl text-base sm:text-lg leading-relaxed font-light text-foreground/80">
          Phillip's work has placed him in front of audiences ranging from small
          executive teams to thousands of conference attendees.
        </motion.p>
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }} className="mt-10 text-xs tracking-[0.25em] uppercase font-bold text-foreground/50">
          Selected appearances and collaborations include:
        </motion.p>
      </div>

      <div data-testid="credibility-marquee" className="border-y border-[#D8D4CA]/70 py-8">
        <Marquee speed={28} gradient={false} pauseOnHover>
          {NAMES.map((n) => (
            <span key={n} className="flex items-center">
              <span className="font-display text-3xl md:text-4xl tracking-tight text-foreground/80 mx-8">{n}</span>
              <span className="w-2 h-2 rotate-45 bg-primary inline-block" aria-hidden="true" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
